export default __webpack_public_path__ + "static/media/Mantenimiento-desk.5cee0ddb.png";